<template>
  <div class="page_content calendar-view">

    <div class="">
      <semester-header :stream-uuid="streamUuid"
      :current-semester="currentSemester"
      :current-year="currentYear"
      :parent-component="'Year'">
      </semester-header>
    </div>

	<div class="planner-view">
		<planner :academic-year="academicYear"
				 :uuid="streamUuid"></planner>

		<div class="schedule-conflict-section">
			<div class="header">Course Information</div>
			<div class="content-section">
				<div v-if="courseToRemove && courseToRemove.uuid" class="content-row">

					<div v-if="scheduleCheckFlagMap.showCourseTitle.enabled" class="desc-cont">
						Course: {{courseToRemove.title}}
					</div>
					<div v-if="scheduleCheckFlagMap.showCRN.enabled" class="desc-cont">
						CRN: {{courseToRemove.CRN}}
					</div>
					<div v-if="scheduleCheckFlagMap.showDays.enabled" class="desc-cont">
						Days: {{courseToRemove.days}}
					</div>
					<div v-if="scheduleCheckFlagMap.showTime.enabled" class="desc-cont">
						Times: {{courseToRemove.times}}
					</div>
					<div v-if="scheduleCheckFlagMap.showUnits.enabled" class="desc-cont">
						Credits: {{courseToRemove.numberOfUnits}}
					</div>
					<div v-if="scheduleCheckFlagMap.showInstructor.enabled" class="desc-cont">
						Instructor: {{courseToRemove.professorOrInstructor}}
					</div>
			          <div v-if="scheduleCheckFlagMap.showBlock.enabled" class="desc-cont">
			            Block: {{courseToRemove.block}}
			          </div>
			          <div v-if="scheduleCheckFlagMap.showGradeLevel.enabled" class="desc-cont">
			            Grade Level: {{courseToRemove.gradeLevel}}
			          </div>
				</div>
			</div>
		</div>

	</div>

  </div>
</template>

<script>
  import '../../../assets/module/css/semester/calendarView.min.css'
  import { mapActions, mapState } from 'vuex'
  import SemesterHeader from '../../semester/components/SemesterHeader'
  import Planner from '../../stream/components/Planner'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'

  export default {
    name: 'semester-planner-view',
    props: ['streamUuid', 'currentSemester', 'currentYear', 'academicYear', 'parentComponent'],
    components: {
      SemesterHeader,
      Planner
    },
    data: () => {
      return {
      }
    },
    mounted () {
      // this.loadData()
    },
    created () {
      this.loadData()
    },
    methods: {
      ...mapActions([
        'populateCourses',
        'removeCourseFromStream'
      ]),
      loadData () {
        let streamUuid = this.streamUuid
        let academicYear = this.academicYear

        if (!streamUuid || !academicYear) {
          return this.$router.push({ name: 'courseSearchResults' })
        }
      }
    },
    computed: {
      ...mapState({
        'courses': state => state.semester.courses,
        'iCalFile': state => state.semester.iCalFile,
        'packages': state => state.institution.packages
      }),
      scheduleCheckFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.SCHEDULE_CHECK_FEATURE_ID
        let coursePlanningPackage = this.getCoursePlanningPackage()
        return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
      },
      isYearView () {
        let parent = this.parentComponent
        return parent === 'Year'
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/semester/components/SemesterPlannerView.vue